import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import ComponentOpaqueDetail from '../../components/component_opaque/ComponentOpaqueDetail';
import { defaultRejectHandler, fromCenti } from '../../utils/utility';
import { createComponentOpaque, createComponentWithMaterials } from '../../redux/component_opaque/component_actions';
import { addMaterialToComponent } from '../../redux/component/component_material_actions';
class ComponentOpaqueCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
    this.materialsToComponent = undefined;
    this.componentDetail = undefined;
  }

  onSaveHandler() {
    const newComponent = this.componentDetail
      .getWrappedInstance()
      .getWrappedInstance()
      .getComponentData();
    const materials = this.materialsToComponent.map((material) => ({...material,thickness:fromCenti(material.thickness)}));
    this.props.createComponentWithMaterials(newComponent, materials);
  }

  render() {
    const { isCreating, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create opaque component')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ComponentOpaqueDetail
            ref={ref => (this.componentDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            materialsToComponent={ref => (this.materialsToComponent = ref)}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="component-opaque-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.component.opaque.errorMessage,
  isCreating: state.component.opaque.isCreating,
  componentDetail: props.component && state.component.opaque.components[props.component.id],
  componentId: state.component.opaque.componentId,
});

const mapDispatchToProps = dispatch => ({
  createComponent: component =>
    defaultRejectHandler(
      dispatch(
        createComponentOpaque(
          component.name,
          component.solar_absorptance_id,
          component.heat_dissipation_id,
          component.description,
          component.image,
          component.cfp_value,
          component.cfp_unit,
        ),
      ),
    ),
  createComponentWithMaterials: (component, materials) =>
    defaultRejectHandler(
      dispatch(
        createComponentWithMaterials(
          component.name,
          component.solar_absorptance_id,
          component.heat_dissipation_id,
          component.description,
          component.image,
          component.cfp_value,
          component.cfp_unit,
          materials,
        ),
      ),
    ),
  addMaterial: (componentId, materialId, thickness, order) =>
    dispatch(
      addMaterialToComponent(
        componentId,
        materialId,
        fromCenti(thickness),
        order,
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ComponentOpaqueCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/component_opaque/ComponentOpaqueCreateModal.js